import React from "react";
import Header_Home from "../Component/Header_Home";
import Header from "../Component/Header";
import Row from "react-bootstrap/Row";
import { Col } from "react-bootstrap";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import "./refundPolicy-styles.css";
import { Grid } from "@mui/material";
import CryptoJS from "crypto-js";

const ChannelPay = () => {
  // const [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();
  const location = useLocation();
  const dataParams = location.state || {};

  const policyNo = dataParams.policyNo || "";
  const age = dataParams.age || "";

  const decryptCardNumber = (encryptedCardNumber, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedCardNumber, secretKey);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted;
  };

  const getUserType = (username) => {
    if (!username) return false;

    if (/^[0-9]/.test(username)) {
      return true;
    }

    if (/^[A-Za-z]/.test(username)) {
      return false;
    }

    return true;
  };

  const username = localStorage.getItem("customer_id");
  const ageChk = Number(localStorage.getItem("age"));
  const decryptedUser = decryptCardNumber(
    username,
    process.env.REACT_APP_ENCRYPT_DATA
  );
  console.log(decryptedUser);
  const isPromptPayDisabled = ageChk < 20 || !getUserType(decryptedUser);

  const goToEditInfoChannel = (channel) => {
    navigate(`/editBank`, {
      state: {
        channelType: channel,
        policyNo: policyNo,
        age: age,
      },
    });
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Header_Home />
      <Header title="เงินคืนตามเงื่อนไขกรมธรรม์" />
      <div className="containers px-4 pt-5">
        <div
          style={{ paddingBottom: 20, position: "relative" }}
          className="card-change-pay big-frame-change-pay"
        >
          {/* กรอบด้านใน */}
          <div className="d-flex px-3 pt-3 pb-3">
            <h2 className="font-size-title">ช่องทางการรับเงิน</h2>
          </div>
          <hr
            className="mx-2"
            style={{ margin: "0px 0px 15px 0px", border: "solid 1px" }}
          />
          {/* <div className="d-flex flex-row" style={{ paddingLeft: "30px" }}>
            <div
              style={{ maxWidth: "250px" }}
              onClick={() => goToEditInfoChannel("bank")}
              className="card-service-change-pay d-flex flex-column text-center align-items-center justify-content-center align-content-center"
            >
              <img
                src={require("../../images/BankCards.svg").default}
                alt="mySvgImage"
                className="img-service-payment-change-pay"
              />
              <p className="fontSizeCard-Change-pay">บัญชีธนาคาร</p>
            </div>
          </div> */}

          <div className="d-flex flex-row justify-content-evenly">
            <div
              onClick={() => goToEditInfoChannel("bank")}
              style={{ maxWidth: "250px" }}
              className="card-service-change-pay d-flex flex-column text-center align-items-center justify-content-center align-content-center"
            >
              <img
                src={require("../../images/BankCards.svg").default}
                alt="mySvgImage"
                className="img-service-payment-change-pay"
              />
              <p className="fontSizeCard-Change-pay">บัญชีธนาคาร</p>
            </div>

            <div
              onClick={
                isPromptPayDisabled
                  ? undefined
                  : () => goToEditInfoChannel("promptpay")
              }
              style={{
                maxWidth: "250px",
                opacity: isPromptPayDisabled ? 0.5 : 1,
                cursor: isPromptPayDisabled ? "not-allowed" : "pointer",
              }}
              className="card-service-change-pay d-flex flex-column text-center align-items-center justify-content-center align-content-center"
              aria-disabled={isPromptPayDisabled}
              tabIndex={isPromptPayDisabled ? -1 : 0}
              title={
                isPromptPayDisabled ? "ต้องอายุอย่างน้อย 20 ปี" : undefined
              }
            >
              <img
                src={require("../../images/promptpay.png")}
                height={30}
                width={35}
                alt="mySvgImage"
                className="img-service-payment-change-pay-promtpay"
              />
              <p className="fontSizeCard-Change-pay">บัญชีพร้อมเพย์</p>
            </div>
          </div>

          <div className="d-flex mt-4 mb-5" style={{ paddingLeft: "17%" }}>
            <p style={{ color: "red", fontFamily: "Prompt-Thin", fontSize: "13px" }}>
              **การทำรายการในครั้งนี้ จะมีผลต่อการรับเงินคืนของทุกกรมธรรม์
            </p>
          </div>

          {isPromptPayDisabled && (
            <div
              style={{
                position: "absolute",
                bottom: 10,
                left: 15,
                fontSize: "13px",
                color: "red",
                fontFamily: "Prompt-Thin",
              }}
            >
              กรณีที่ไม่สามารถทำรายการได้ โปรดติดต่อฝ่ายลูกค้าสัมพันธ์ 026483600
            </div>
          )}
        </div>

        <Row className="d-flex flex-column mt-5 mb-5">
          <Col className="d-flex justify-content-center px-5">
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6}>
                <button
                  style={{ marginTop: "-20px" }}
                  onClick={goBack}
                  type="button"
                  className="btn-checkout-back w-100 p-2 bold-detail"
                >
                  ย้อนกลับ
                </button>
              </Grid>
            </Grid>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ChannelPay;
